'use client';

import { useField } from 'formik';
import type { ComponentProps } from 'react';

import { PhoneInput } from 'src/shared/ui/PhoneInput';

import styles from '../index.module.css';

type FieldPhoneInputProps = Omit<ComponentProps<typeof PhoneInput>, 'name'> & {
  name: string;
};

export const FieldPhoneInput = ({ name, onChange, ...props }: FieldPhoneInputProps) => {
  const [field, meta] = useField<string | null>(name);

  return (
    <PhoneInput
      {...props}
      {...field}
      inputClassName={styles.fieldInput}
      fieldClassName={styles.controllerInput}
      value={field.value ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
